import { WordopolisGame } from "../../../../../../graphql/helpers/isWordopolisGame";

import styles from "./WordopolisPreview.module.scss";
import { useMemo, useRef } from "react";
import { Wordopolis } from "@datagame/ui";

const { Cell, Stage, Background } = Wordopolis;

export interface WordopolisPreviewProps {
  game: WordopolisGame;
}

const WORDOPOLIS_STAGE_SIZE = 600;

export const WordopolisPreview = ({ game }: WordopolisPreviewProps) => {
  const parentRef = useRef<HTMLDivElement>(null);

  const {
    board: flattenBoard,
    boardBackgroundColor,
    boardBackgroundImage,
    boardColor,
    numberOfColumns,
    numberOfRows,
  } = game.configuration;

  const stageSize = useMemo(() => {
    const longerSide = Math.max(numberOfColumns, numberOfRows);

    return {
      width: Math.floor((numberOfColumns / longerSide) * WORDOPOLIS_STAGE_SIZE),
      height: Math.floor((numberOfRows / longerSide) * WORDOPOLIS_STAGE_SIZE),
    };
  }, [numberOfColumns, numberOfRows, flattenBoard]);

  const { width, height } = stageSize;

  const cellSize = Math.ceil(Math.min(width, height) / Math.min(numberOfColumns, numberOfRows));

  const board = useMemo(() => {
    const chunkSize = numberOfColumns;
    const array: string[][] = [];
    if (!flattenBoard) {
      return array;
    }
    for (let i = 0; i < flattenBoard.length; i += chunkSize) {
      const chunk = flattenBoard.slice(i, i + chunkSize);
      array.push(chunk);
    }
    return array;
  }, [flattenBoard, numberOfColumns, numberOfRows]);

  return (
    <div className={styles.wordopolisBoard}>
      <Stage size={stageSize} parentRef={parentRef}>
        <Background size={stageSize} color={boardBackgroundColor} backgroundImage={boardBackgroundImage || undefined} />
        {board.map((row, rowIndex) => {
          return row.map((cell: string, cellIndex: number) => (
            <Cell
              key={`${rowIndex}-${cellIndex}`}
              row={rowIndex}
              cell={cellIndex}
              size={cellSize}
              fontColor={boardColor}
              content={cell.toUpperCase()}
              onClick={() => undefined}
            />
          ));
        })}
      </Stage>
    </div>
  );
};
